import NavigationHeader from "../components/Layout/NavigationHeader";

const PrivacyPage = () => {
  return (
    <div className={"page_content"}>
      <NavigationHeader />
      <h2>
        Privacy and Cookies
      </h2>
      <span>
        We value your privacy.
        A cookie is used to store your authentication token.
        No cookie is used to track your activity on this web application or any other web site.
      </span>
    </div>);
};

export default PrivacyPage;
